export default __webpack_public_path__ + "static/contact2-dfa8041c30adbd60819508a57ee6b1e3.png";